import { render, staticRenderFns } from "./questionSet.vue?vue&type=template&id=fa71536c&"
import script from "./questionSet.vue?vue&type=script&lang=js&"
export * from "./questionSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports